var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 11.5304 21.7893 12.0391 21.4142 12.4142C21.0391 12.7893 20.5304 13 20 13H13.68L14.64 17.57C14.66 17.67 14.67 17.78 14.67 17.89C14.67 18.3 14.5 18.68 14.23 18.95L13.17 20L6.59 13.42C6.22 13.05 6 12.55 6 12V2C6 1.46957 6.21071 0.960859 6.58579 0.585787C6.96086 0.210714 7.46957 0 8 0H17C17.83 0 18.54 0.5 18.84 1.22L21.86 8.27C21.95 8.5 22 8.74 22 9V11ZM0 0H4V12H0V0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeFilled);
export default __webpack_public_path__ + "static/media/dislikeFilled.b28732495aafe98bf34b19f3a18b87ca.svg";
export { ForwardRef as ReactComponent };